import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Form, Radio, Tooltip } from 'antd';
import classNames from 'classnames';

export default function Rights(props) {
    const requestTypeId = Form.useWatch('requestTypeId', props.form);

    const rightDescriptionList =
        Form.useWatch('rightDescriptionList', props.form) ?? [];

    const getDescription = () => {
        if (!requestTypeId) return '';
        const find = rightDescriptionList?.find(
            (item) => item?.mdataSubjectRightId === requestTypeId
        );
        return props?.lang === 'TH' ? find?.descriptionTh : find?.descriptionEn;
    };

    return (
        <div className="w-full h-full bg-white p-4 px-6">
            <div
                className="font-bold text-xl pb-3"
                style={{
                    color: props?.fontStyle?.textCardColor,
                }}
            >
                {props.lang === 'TH'
                    ? 'รายละเอียดเบื้องต้นเกี่ยวกับผู้ยื่นคำร้อง'
                    : 'Contact details of Requester'}
            </div>
            <div
                className="font-bold flex items-center space-x-3 pb-1"
                style={{
                    color: props?.fontStyle?.textCardColor,
                    fontSize: props?.fontStyle?.fontSize,
                }}
            >
                <div>
                    {props.lang === 'TH'
                        ? 'ระบุประเภทการขอใช้สิทธิ'
                        : 'Please specify type of Data Subject Rights Request'}
                    <span
                        className="ml-1.5 pb-1 text-[#ff4d4f] font-medium text-sm lead-[1px]"
                        style={{ fontFamily: 'SimSun, sans-serif' }}
                    >
                        *
                    </span>
                </div>
                <div>
                    <Tooltip
                        placement="right"
                        overlayClassName="min-w-[30%]"
                        title={
                            props.lang === 'TH'
                                ? 'กรณีที่เจ้าของข้อมูลพบว่าบริษัทฯ ประมวลผลข้อมูลส่วนบุคคลของท่าน โดยไม่ขอความยินยอม โดยเจ้าของข้อมูลสามารถระบุแหล่งที่มา ของข้อมูลที่พบเห็นได้ เช่น URL , Link ภายใน Web หรือ Application ของบริษัท'
                                : 'In case that the data owner finds that the company Process your personal data without consent The owner of the data can specify the source of the data that can be seen, such as URL, Link within the Web or the Company Application.'
                        }
                    >
                        <button
                            type="button"
                            className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple"
                        >
                            <ExclamationCircleOutlined />
                        </button>
                    </Tooltip>
                </div>
            </div>
            <Form.Item name="requestTypeId">
                <Radio.Group
                    className={classNames('grid w-full', {
                        'grid-cols-2 gap-3': props?.platform !== 'Mobile',
                        'grid-cols-1': props?.platform === 'Mobile',
                    })}
                >
                    {props?.requestType?.map((item) => {
                        return (
                            <Radio
                                style={{
                                    color: props?.fontStyle?.textCardColor,
                                    fontSize: props?.fontStyle?.fontSize,
                                }}
                                key={item?.requestTypeId}
                                value={item?.requestTypeId}
                            >
                                <div className="flex items-center">
                                    <div>
                                        {props?.lang === 'EN'
                                            ? item?.requestTypeNameEn
                                            : item?.requestTypeShortName}
                                    </div>

                                    <Tooltip
                                        placement="rightTop"
                                        title={
                                            <div
                                                className="whitespace-pre-line"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        props.lang === 'TH'
                                                            ? item?.hintTh
                                                            : item?.hintEn,
                                                }}
                                            />
                                        }
                                    >
                                        <span className="text-purple pl-1 pt-[3px]">
                                            <ExclamationCircleOutlined />
                                        </span>
                                    </Tooltip>
                                </div>
                            </Radio>
                        );
                    })}
                </Radio.Group>
            </Form.Item>
            {getDescription() && (
                <div
                    className="p-4 mb-4 rounded-md bg-[#F9FAFE] whitespace-pre-line"
                    style={{ border: '1px solid #7B67FB' }}
                >
                    <strong>
                        {props?.lang === 'EN'
                            ? 'Actions after the company receives the request'
                            : 'การดำเนินการหลังจากที่บริษัทได้รับคำขอ'}
                    </strong>
                    <div>{getDescription()}</div>
                </div>
            )}
        </div>
    );
}
